<template>
  <div>
    <div v-if="cleaners && cleaners.length > 0">
      <div
        v-for="cleaner in cleaners"
        :key="cleaner.uuid"
        :style="{
          opacity: cleaner.active === 0 ? 0.5 : 1,
          'font-size': '14px',
          'line-height': '16px'
        }"
        class="my-1 d-flex justify-space-between"
        :title="
          cleaner.active === 0
            ? lang($store, `sap/listings.global.not_active`)
            : false
        "
      >
        <div class="d-flex align-center">
          <p>
          <v-icon small>mdi-spray-bottle</v-icon>
          {{ cleaner.name }}
          <a
            v-if="cleaner && cleaner.phone"
            :href="'tel:' + formatPhoneForLink(cleaner.phone)"
          >
            {{ cleaner.phone }}
          </a>
          <span v-if="cleaner.orders_counter">
          <strong>( {{ $t('negatives.orders') + ': ' + cleaner.orders_counter }} )</strong>
          </span>
          <a
            v-if="cleaner.checklist_pdf"
            target="_blank"
            :href="cleaner.checklist_pdf"
            class="mr-2 text-decoration-none"
          >
            <v-icon color="red">mdi-file-pdf-box</v-icon>
          </a>
          </p>
        </div>
        <v-icon
          @click="$emit('remove-cleaner', cleaner.uuid)"
          style="cursor: pointer"
          >mdi-close-circle</v-icon
        >
      </div>
    </div>
    <div v-else >
      <div v-if="!needCaseCleaningStarted || (needCaseCleaningStarted && !cleaningStarted)" class="red--text">
        <v-icon small>mdi-spray-bottle</v-icon>
        {{ lang($store, `sap/listings.orders.cleaner_not_set`) }}
      </div>
    </div>
  </div>
</template>

<script>
import { formatPhoneForLink } from '../../utils';

export default {
  name: 'CleanersLine',
  props: {
    cleaners: {
      type: Array,
      default: () => []
    },
    needCaseCleaningStarted: {
      type: Boolean,
      default: false,
    },
    cleaningStarted: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      formatPhoneForLink
    };
  }
};
</script>

<style scoped></style>
